import type { FieldError } from "react-hook-form";
import styles from "./ErrorMessage.module.scss";

type ErrorMessageProps = {
  error?: FieldError;
};

export const ErrorMessage = ({ error }: ErrorMessageProps) => {
  if (!error?.message) {
    return null;
  }

  return <p className={styles.errorMessage}>{error?.message}</p>;
};
